import React from 'react';

const Extensions = ({ className }) => (
    <svg viewBox="0 0 23.8 23.8" className={`extensions ${className}`}>
        <title>Extensions</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M9.9,22.9h-8l-1-1V5.9l1-1h7l1,1Z"/>
                <path d="M18.9,14.9v7l-1,1H1.9l-1-1v-8h17Z"/>
                <path d="M21.9,9.9h-7l-1-1v-7l1-1h7l1,1v7Z"/>
            </g>
        </g>
    </svg>
);

export default Extensions;